export const PACKAGES_SECTION_ID = 'reservation-packages';
export const BLIK_LENGTH = 6 as const;

export const RESERVATION_FLOW_MODE_PARAM = 'mode';

/**
 * How the reservation flow was entered. `create` makes a new reservation and
 * refuses if one is already pending; `continue` resumes the existing pending
 * reservation and redirects out if there is none. Absence of the param is
 * treated as `create` — `/reservation` is the make-a-reservation route.
 */
export const ReservationFlowMode = {
  Create: 'create',
  Continue: 'continue',
} as const;

export type ReservationFlowMode = (typeof ReservationFlowMode)[keyof typeof ReservationFlowMode];

export const PaymentMethod = {
  Blik: 'blik',
  Paynow: 'paynow',
  Wallet: 'wallet',
} as const;
